module.exports = __webpack_public_path__ + "img/2.30690328.jpg";